export const RESET = 'GAME_ORDER_LIST_RESET'
export const SET_ITEMS = 'GAME_ORDER_LIST_SET_ITEMS'
export const SET_ERROR = 'GAME_ORDER_LIST_SET_ERROR'
export const SET_VIEW = 'GAME_ORDER_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'GAME_ORDER_LIST_TOGGLE_LOADING'
export const SET_VIOLATIONS = 'GAME_ORDER_LIST_SET_VIOLATIONS'

export const SET_CATEGORIES = 'GAME_ORDER_LIST_SET_CATEGORIES'
export const SET_CATEGORIES_TOGGLE_LOADING = 'GAME_ORDER_LIST_SET_CATEGORIES_TOGGLE_LOADING'

export const SET_TERRITORIES = 'GAME_ORDER_LIST_SET_TERRITORIES'
export const SET_TERRITORIES_TOGGLE_LOADING = 'GAME_ORDER_LIST_SET_TERRITORIES_TOGGLE_LOADING'

export const SET_GAMES = 'GAME_ORDER_LIST_SET_GAMES'
export const SET_GAMES_TOGGLE_LOADING = 'GAME_ORDER_LIST_SET_GAMES_TOGGLE_LOADING'
